import { render, staticRenderFns } from "./ColumnSideBar.vue?vue&type=template&id=39e5dadc&scoped=true&"
import script from "./ColumnSideBar.vue?vue&type=script&lang=js&"
export * from "./ColumnSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ColumnSideBar.vue?vue&type=style&index=0&id=39e5dadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e5dadc",
  null
  
)

export default component.exports